// extracted by mini-css-extract-plugin
export default {"styles":"styles___WYqfh","content":"content___T1JAA","header":"header___TUqFk","body":"body___P13r8","bottom":"bottom___Mc7a8","errorTip":"errorTip___CMPxa"};